// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SIdeDrawer_SideDrawer__372pj","StyledHorizontal":"SIdeDrawer_StyledHorizontal__zk3uK","Open":"SIdeDrawer_Open__2PUCB","Close":"SIdeDrawer_Close__VPW-3"};